import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  useUploadexcelMutation,
} from "../redux/features/user/userApi";
import Navbar from "../Components/Navbar";
import { useNavigate } from "react-router-dom";

const Upload = () => {
  const navigate = useNavigate();
  const [selectedExcel, setSelectedExcel] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const [uploadExcel, { isLoading: isUploadingExcel }] = useUploadexcelMutation();

  const handleExcelChange = (event) => {
    const file = event.target.files?.[0] || null;
    setSelectedExcel(file);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e, setFile) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

  const handleSubmitExcel = async (event) => {

    console.log(`----41-----,Upload------>`,);

    console.log(`selectedExcel----43-----,Upload------>`, selectedExcel);

    event.preventDefault();
    if (!selectedExcel) {
      toast.error("Please select a CSV/Excel file first");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", selectedExcel);
      const response = await uploadExcel(formData).unwrap();
      console.log(`response----50-----,Upload------>`, response);
      toast.success("File uploaded successfully");
      if (response) {
        navigate("/upload");
      }
      setSelectedExcel(null);
      event.target.reset();
    } catch (error) {
      console.log(`error----60-----,Upload------>`, error);
      const message = error?.data?.message || error?.error || "Upload failed";
      toast.error(message);
    }
  };

  const downloadSampleSheet = () => {
    // Create sample data for Excel sheet
    const sampleData = [
      ['email', 'currency', 'amount', 'usd_value', 'transferid', 'ordertype'],
      ['user1@example.com', 'kait', '1000', '0.0271', 'TXN001', `['send', 'receive']`],
    ];

    // Convert to CSV format
    const csvContent = sampleData.map(row => row.join(',')).join('\n');

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sample_upload_sheet.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success("Sample Format downloaded successfully");
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Upload Center</h1>
            <p className="text-lg text-gray-600">Upload Excel/CSV files to the system</p>
          </div> */}

          <div className="max-w-2xl mx-auto">
            {/* Excel Upload Card */}
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-2xl font-semibold text-gray-900">Upload Excel/CSV</h2>
                  <p className="text-gray-500">Support for CSV, XLS, XLSX files</p>
                </div>
              </div>

              {/* Download Sample Sheet Button */}
              <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-sm font-medium text-blue-900">Sample Format Template</h3>
                    <p className="text-xs text-blue-700 mt-1">Download our Excel sheet to see the required format</p>
                  </div>
                  <button
                    onClick={downloadSampleSheet}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center"
                  >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Download Sample
                  </button>
                </div>
              </div>

              <form onSubmit={handleSubmitExcel}>
                <div
                  className={`relative border-2 border-dashed rounded-xl p-8 text-center transition-colors ${dragActive ? 'border-green-400 bg-green-50' : 'border-gray-300 hover:border-gray-400'
                    }`}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={(e) => handleDrop(e, setSelectedExcel)}
                >
                  <input
                    type="file"
                    accept=".csv,.xls,.xlsx"
                    onChange={handleExcelChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    id="excel-upload"
                  />
                  <div className="space-y-4">
                    <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                      <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <div>
                      <label htmlFor="excel-upload" className="cursor-pointer">
                        <span className="text-green-600 hover:text-green-500 font-medium">Click to upload</span>
                        <span className="text-gray-500"> or drag and drop</span>
                      </label>
                      <p className="text-xs text-gray-500 mt-1">CSV, XLS, XLSX</p>
                    </div>
                  </div>
                </div>

                {selectedExcel && (
                  <div className="mt-4 p-4 bg-green-50 rounded-lg border border-green-200">
                    <div className="flex items-center">
                      <svg className="w-5 h-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <span className="text-sm font-medium text-green-800">{selectedExcel.name}</span>
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isUploadingExcel || !selectedExcel}
                  className="mt-6 w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-xl transition-colors duration-200 flex items-center justify-center"
                >
                  {isUploadingExcel ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Uploading...
                    </>
                  ) : (
                    'Upload Excel/CSV'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Upload;

